export default "__VITE_ASSET__B8VF97SF__"